export const CONTRACT_UPDATED_STATUS = 'updated';
